// extracted by mini-css-extract-plugin
module.exports = {"container":"CustomTooltip_container_16fAw","bottom":"CustomTooltip_bottom_1DtIk"};